import { render, staticRenderFns } from "./ModalAdd.vue?vue&type=template&id=326b53bc&scoped=true&"
import script from "./ModalAdd.vue?vue&type=script&lang=js&"
export * from "./ModalAdd.vue?vue&type=script&lang=js&"
import style0 from "./ModalAdd.vue?vue&type=style&index=0&id=326b53bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326b53bc",
  null
  
)

export default component.exports